import objPath from 'object-path'
import { buildQuery } from '@cwp/utils'
import { fetchJSON } from '@ampdx/common-utils/src/fetch.js'
import { getEnvironment } from '@ampdx/common-utils/src/common-utils.js'
import { push } from '../_utils.ts'
import { formatPhone, normalizeSpaces } from './_utils.ts'

function clean(data) {
  const obj = objPath(data || {})
  const type = obj.get('facePrflTyp') === 'Individual' ? 'advisor' : 'team'
  const isAdvisor = type === 'advisor'
  const images = {}
  const urls = {}
  const social = {}
  const designations =
    isAdvisor &&
    obj
      .get('facePrflDistributor.facePrflDstrDesignations', [])
      .map(item => item.desgAcronym)
      .filter(Boolean)
      .join(', ')
  const { firstNm, lastNm, midNm } = obj.get('facePrflDistributor')

  // Display name
  const name = (() => isAdvisor
      ? normalizeSpaces(`${firstNm} ${midNm} ${lastNm}`)
      : obj.get('prflPractice.pracNm') || obj.get('prflNkNm'))()

  const title = isAdvisor && obj.get('facePrflDistributor.profTtl')

  //co-brand
  const brandTypCd = obj.get('prflBrand.brandProfile.brandTypCd')
  const brandSegmTyp = obj.get('prflBrand.brandProfile.brandSegmTyp')
  const cobrand = brandTypCd === 'Ameriprise Financial co-branded - AFIG' && brandSegmTyp === 'Full'
  const brandLogos = obj.get('prflBrand.brandContent.brandLogos', [])
  const imageLarge = brandLogos.find(
    a => a.logoDimn === '1080x280' && a.logoColor === 'Full Color' && a.logoFlTyp === 'JPG'
  )
  const imageSmall = brandLogos.find(
    a => a.logoDimn === '1080x280' && a.logoColor === 'Full Color' && a.logoFlTyp === 'JPG'
  )
  if (
    window.digitalData &&
    window.digitalData.page &&
    window.digitalData.page.pageInfo &&
    cobrand
  ) {
    window.digitalData.page.pageInfo.partner = obj.get('prflBrand.brandContent.brandNm')
  }

  // Image
  obj.get('prflImages', []).forEach(image => {
    const sizeCode = image.photoSizeCd.replace(' image', '').toLowerCase()
    images[sizeCode] = image.photoImgURL
  })

  // Urls
  obj.get('prflSocialMediaURLs', []).forEach(item => {
    const { mediaTypCd, URL } = item

    switch (mediaTypCd) {
      case 'siteurl':
      case 'TeamWebsiteUrl':
        urls.site = URL
        break
      case 'referme':
        urls.referme = URL
        break
      case 'FacebooklinkUrl':
      case 'TeamFacebooklinkUrl':
        social.facebook = URL
        break
      case 'linkedinurl':
        social.linkedin = URL
        break
      case 'twitterurl':
        social.twitter = URL
        break
      case 'BiopageUrl':
        urls.site = URL
        break
    }
  })

  return {
    designations,
    email: obj.get('prflEmail.emailAddr'),
    id: obj.get('facePrflDistributor.facePrflDstrId'),
    image: images.large || images.medium || images.small,
    name,
    phone: formatPhone(obj.get('prflTelephone.teleNbr')),
    title,
    type,
    urls,
    social,
    cobrand,
    imageLarge,
    imageSmall,
  }
}

/*
 * {
 *   designations: '',
 *   email: '',
 *   id: '',
 *   image: '',
 *   name: '',
 *   phone: '',
 *   title: '',
 *   type: 'advisor|team',
 *   urls: {
 *     'referme|site': ''
 *   },
 *   social: {
 *     linkedin: '',
 *     facebook: '',
 *     twitter: ''
 *   }
 * }
 */
async function getFaceProfile(options = {}) {
  const result = {
    data: null,
    errors: [],
  }

  /**
   * local uri path can be replaced with any mock json file for local testing
   * e.g. '/assets/amp-monorepo-microsites/mocks/faceProfile-comerica.json'
   */
  if (options.id) {
    try {
      const env = getEnvironment()
      const uri = `${
        env === 'local'
          ? '/assets/amp-monorepo-microsites/mocks/faceProfile-comerica.json'
          : `/api/faceProfile?${buildQuery({
              facePrflId: options.id,
            })}`
      }`
      const data = await fetchJSON(uri)
      result.data = clean(data)
    } catch (error) {
      result.errors = push(result.errors, error)
    }
  }

  return result
}
export { getFaceProfile }
